import React from 'react';
import { SALE_STATUSES } from '../constants/saleStatuses';

const StatusBadge = ({ status }) => {
  const { label, className } = SALE_STATUSES[status];

  return (
    <span className={`text-base font-medium px-4 py-1.5 rounded-full bg-white dark:bg-gray-800 ${className}`}>
      {label}
    </span>
  );
};

export default StatusBadge; 